export const CREATING_WEEKLY_REPORT = 'creatingWeeklyReport'
export const DOCUMENTS_RECEIVED = 'documentsReceived'
export const DOCUMENT_RECEIVED = 'documentReceived'

export const createWeeklyReport = content => ({
  type: CREATING_WEEKLY_REPORT,
  payload: content
})

export const receiveDocuments = documents => ({
  type: DOCUMENTS_RECEIVED,
  payload: documents
})

export const receiveDocument = document => ({
  type: DOCUMENT_RECEIVED,
  payload: document
})



// WEBPACK FOOTER //
// ./src/Documents/actions.js